import {
  SELF_EMPLOYMENT,
  ACCOUNTS_RECEIVABLE,
  SET_PARAM,
  SET_SELF_EMPLOYMENT,
  SET_SELF_EMPLOYMENT_PARAM,
  SET_ACCOUNTS_RECEIVABLE,
  MERCHANT_ACCOUNTS,
  SET_MERCHANT_ACCOUNTS,
  SET_INITIAL_COMPLIANCE,
  SET_INITIAL_BUSINESS_INFO,
} from './constants';

export default {
  [SET_PARAM]: (state, { type, value }) => {
    state[type] = value;
  },
  [SET_SELF_EMPLOYMENT_PARAM]: (state, { type, value }) => {
    state[SELF_EMPLOYMENT][type] = value;
  },
  [SET_SELF_EMPLOYMENT]: (state, payload) => {
    state[SELF_EMPLOYMENT] = { ...payload };
  },
  [SET_ACCOUNTS_RECEIVABLE]: (state, data) => {
    state[ACCOUNTS_RECEIVABLE] = [...data];
  },
  [SET_MERCHANT_ACCOUNTS]: (state, data) => {
    state[MERCHANT_ACCOUNTS] = [...data];
  },
  [SET_INITIAL_COMPLIANCE]: (state, val) => {
    state.initialCompliance = val;
  },
  [SET_INITIAL_BUSINESS_INFO]: (state, data) => {
    state.initialBusinessInfo = data;
  },
};
